export default __webpack_public_path__ + "static/media/23ccfc28624428ad.7fbe5805ecba83ebb45859895adf70c3.svg";